var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.331,
    height: 31.423,
    viewBox: "0 0 39.331 31.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reload",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_138_1",
    "data-name": "Component 138 \\u2013 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M86.716,112a14.907,14.907,0,0,0-14.594,11.967l-2.276-3.033L67.2,122.919l4.962,6.615a1.654,1.654,0,0,0,2.315.331l6.615-4.962-1.985-2.646-3.82,2.866A11.569,11.569,0,0,1,96.748,121.1l2.863-1.656A14.945,14.945,0,0,0,86.716,112Z",
    transform: "translate(-67.2 -112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M158.695,240.623a1.65,1.65,0,0,0-2.315-.265l-6.285,4.96,2.049,2.595,3.437-2.714a11.569,11.569,0,0,1-21.437,3.9l-2.863,1.657a14.879,14.879,0,0,0,27.514-4.712l2.61,3.263,2.583-2.066Z",
    transform: "translate(-124.656 -226.771)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.80b5ad5c54918dc98d4b0a92022632b3.svg";
export { ForwardRef as ReactComponent };